import React from 'react';
import ReFundVoucherDetail from '../../components/RefundVoucher/RefundVoucherDetail';

const RefundVoucherDetailPage = () => {
  return <ReFundVoucherDetail />;
};

export default RefundVoucherDetailPage;
